import { Team, type Board } from '@apps/www/src/__generated__/graphql';
import SVInviteUsersContainer from '@apps/www/src/www/containers/SVInviteUsersContainer';
import useAuthTeam from '@apps/www/src/www/hooks/useAuthTeam';
import SVModal, { useModalClose } from '@pkgs/shared-client/components/SVModal';
import InviteType from '@pkgs/shared/enums/InviteType';

const _SVInviteUsersModal = (props: {
	maxUsersCount: number;
	type: typeof InviteType.TEAM | typeof InviteType.BOARD;
	resourceID: Board['_id'] | Team['_id'];
}) => {
	const close = useModalClose();
	const userTeam = useAuthTeam();

	return (
		<>
			<SVModal.Title>
				{props.type === InviteType.TEAM
					? `Invite users to ${userTeam?.name || 'your team'}`
					: 'Invite Collaborators'}
			</SVModal.Title>
			<SVInviteUsersContainer
				onSuccess={close}
				newBoard={false}
				isJustInviteModal
				{...props}
			/>
		</>
	);
};

const SVInviteUsersModal = SVModal.create(_SVInviteUsersModal, {
	className: 'w-[380px] -sm:w-full',
});

export default SVInviteUsersModal;
